import { schema } from 'normalizr';
import user from 'reducers/schemas/user';
import userPlayer from 'reducers/schemas/userPlayer';

export default new schema.Entity('players', {
    users: [user],
    related_user: userPlayer,
    updated_by: user,
    main_user: user,
});
